/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_Group_CountInputs */

const vi_shop_category_group_count = /** @type {(inputs: Shop_Category_Group_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số nhóm`)
};

/**

* @param {Shop_Category_Group_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_group_count = /** @type {((inputs?: Shop_Category_Group_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_Group_CountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_group_count(inputs)
});